import { render, staticRenderFns } from "./ClassImages.vue?vue&type=template&id=5ae79952&"
import script from "./ClassImages.vue?vue&type=script&lang=js&"
export * from "./ClassImages.vue?vue&type=script&lang=js&"
import style0 from "./ClassImages.vue?vue&type=style&index=0&id=5ae79952&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports